import React, { useState, useEffect } from 'react'
import './NavigationPanel.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const NavigationPanel = ({ showMenuSidebar, children, setShowMenuSidebar, left, heading }) => {
    const [currentDimensions, setCurrentDimensions] = useState(window?.innerWidth)

    const handleOrientationChange = () => {
        setCurrentDimensions(window.innerWidth)
    };

    useEffect(() => {
        window.addEventListener('resize', handleOrientationChange);
    
        return () => {
          window.removeEventListener('resize', handleOrientationChange);
        };
    }, []);

    return (
            <div
                className='navigationPanelMainContainer'
                style={{
                    transform: showMenuSidebar ? 'translateX(0)' : left ? 'translateX(-100%)' : 'translateX(100%)',
                    left: left ? '0' : 'auto',
                    right: left ? 'auto' : '0',
                }}
            >
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 20px 8px"}}>
                    <div style={{fontSize: "large", fontWeight: "600"}}>{heading}</div>
                    <div
                        onClick={() => setShowMenuSidebar(false)}
                        style={{
                            cursor: 'pointer',
                            color: 'black'
                        }}
                    >  
                        <FontAwesomeIcon icon={faXmark} size="xl" style={{cursor:"pointer"}}/>
                    </div>
                </div>
                {heading && <hr style={{height: '1px', backgroundColor: 'grey'}}/>}
                {children}
            </div>
    )
}

export default NavigationPanel